import { graphql } from 'app/generated/gql'

/**
 * `createdDate` and `updatedDate` are deliberately absent from these selection
 * sets, against the usual "request every model field" rule. Both are
 * `DateTime!` in the schema but null on every imported record, so asking for
 * either returns INTERNAL_SERVER_ERROR and nulls the whole response rather
 * than just that field. Verified against dev on 2026-08-21; `version` is fine.
 * Tracked as TRK-5574; restore them once it ships.
 *
 * Still applies after the `MedicalNote` to `CommLog` rename (TRK-5721): that
 * reindex copied the imported records verbatim and the new sync is forward
 * only, so only records written since carry the two dates.
 */
export const COMM_LOG_LIST_QUERY = graphql(`
  query CommLogEntries($search: String, $pagination: PaginationInput, $sort: SortInput) {
    commLogs(search: $search, pagination: $pagination, sort: $sort) {
      total
      page
      hits {
        id
        orgId
        workspaceId
        locationId
        vendorId
        patientId
        pmsPatientId
        mode
        commType
        sentOrReceived
        note
        userNum
        commSource
        programNum
        channel
        provider
        subject
        sourceId
        commDate
        commEndDate
        pmsUpdatedDate
        version
      }
    }
  }
`)

/**
 * Feeds the tab badge. Runs with the drawer's other loads so the count is
 * there before the tab is opened, while the list itself stays lazy.
 */
export const COMM_LOG_COUNT_QUERY = graphql(`
  query CommLogCount($search: String) {
    commLogs(search: $search, pagination: { limit: 0 }) {
      total
    }
  }
`)
